import React, { useState } from 'react';
import NITALogo from '../_images/nita-itco-combo-home.png';

export default function TopBar({ home, onStateChange }) {
  const [showText, setShowText] = useState('');

  const handlePress = async (tag) => {
    await localStorage.setItem('link', tag);
    return window.location.reload();
  };

  const handleHomeText = (newState) => {
    setShowText(newState);
    onStateChange(newState);
  };

  return (
    <div className="w-full bg-white shadow-md flex flex-col">
      {/* Top stripe */}
      <div className="h-1 bg-[#f3f3f3]" />

      {/* Main bar */}
      <div className="flex items-center justify-between px-4 py-3 md:px-6 md:py-4 lg:py-5">
        {/* Logo Section */}
        <div
          className="flex items-center cursor-pointer"
          onClick={async () => {
            if (localStorage.getItem('token')) {
            } else {
              await localStorage.clear();
            }
            return window.location.reload();
          }}
          >
          <img
            src={NITALogo}
            className="h-10 sm:h-14 md:h-16 lg:h-20 object-contain"
            alt="NITA Logo"
          />
        </div>

        {/* Navigation Buttons */}
        {home && (
          <div className="flex flex-wrap items-center justify-center gap-1 md:gap-2">
            {[
              { label: 'Certification', value: 'certification' },
              { label: 'IT Services', value: 'it_services' },
              { label: 'E Transactions', value: 'e_transactions' },
              { label: 'IT Institutions', value: 'training_institution' },
              { label: 'IT Products', value: 'it_products' },
              { label: 'IT Consultants', value: 'individual_it_service_providers' },
              {
                label: 'Consumer Protection',
                link: 'https://consumer.nita.go.ug/',
                external: true,
              },
              { label: 'Help', value: 'help_and_support' },
              { label: 'Login', value: 'sign_in' },
            ].map((button, index) => (
              button.external ? (
                <a
                  key={index}
                  href={button.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 md:p-3 text-sm md:text-base bg-white hover:bg-lime-200 rounded-full text-black-500 tracking-tight"
                >
                  {button.label}
                </a>
              ) : (
                <button
                  key={index}
                  onClick={() =>
                    button.value === 'sign_in' ? handlePress(button.value) : handleHomeText(button.value)
                  }
                  className="p-2 md:p-3 text-xs md:text-base bg-white hover:bg-lime-200 rounded-full text-black-500 tracking-tight"
                >
                  {button.label}
                </button>
              )
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
